// extracted by mini-css-extract-plugin
export default {"main-container":"Main_main-container__gOJxc","loading-backdrop":"Main_loading-backdrop__ag5Dt"};